import Vue from 'vue'
import SeamlessScroll from 'vue-seamless-scroll'

Vue.use(SeamlessScroll)
